import React from "react";

const Footer = (props) => {
  return <footer className="inner-buffer">App Version: v2.01.01</footer>;
};

export default Footer;
